import {
  IStaffManagementParams, IStaffManagement, IStaffManagementAddParams, IStaffManagementEditParams, IStoreManagementParams, IStoreManagement,
  IStoreManagementAddParams,
  IStoreManagementEditParams,
  IStoreStaffItem,
  IStoreChangePhoneApplyParams,
  IStoreChangePhoneVerifyParams,
} from '../../types/terminal-management/businessScenarios';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 门店列表
 */
export async function queryStoreList(companyId?: number) {
  let data = [];

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/pay/yop/store/list`, { companyId });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 门店员工列表
 */
export async function queryStoreStaffList(companyId?: number) {
  let data = [] as IStoreStaffItem[];

  try {
    const { code, context, message } = await Http.get<IStoreStaffItem[]>(`${hostUrl}/pay/yop/staff/users-2choose`, { companyId });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 员工列表
 */
export async function queryStaffPageList(param: IStaffManagementParams) {
  let data = [] as IStaffManagement[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IStaffManagementParams;

  try {
    const { code, context, message } = await Http.post<{ data: IStaffManagement[]; total: number }>(`${hostUrl}/pay/yop/staff/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IStaffManagement[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 新增员工收款
 */
export async function addStaff(param: IStaffManagementAddParams) {

  param = JSON.parse(JSON.stringify(param)) as IStaffManagementAddParams;

  try {
    const { code, message } = await Http.post<IStaffManagementAddParams>(`${hostUrl}/pay/yop/staff`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 修改员工收款
 */
export async function editStaffParams(param: IStaffManagementEditParams) {

  param = JSON.parse(JSON.stringify(param)) as IStaffManagementEditParams;

  try {
    const { code, message } = await Http.put<IStaffManagementEditParams>(`${hostUrl}/pay/yop/staff`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 删除员工收款
 */
export async function delStaffParams(staffId: string) {

  try {
    const { code, message } = await Http.delete<any>(`${hostUrl}/pay/yop/staff?staffId=${staffId}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 店铺列表
 */
export async function queryStorePageList(param: IStoreManagementParams) {
  let data = [] as IStaffManagement[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IStoreManagementParams;

  try {
    const { code, context, message } = await Http.post<{ data: IStoreManagement[]; total: number }>(`${hostUrl}/pay/yop/store/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IStoreManagement[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 新增门店
 */
export async function addStore(param: IStoreManagementAddParams) {

  param = JSON.parse(JSON.stringify(param)) as IStoreManagementAddParams;

  try {
    const { code, message } = await Http.post<IStoreManagementAddParams>(`${hostUrl}/pay/yop/store`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 修改门店
 */
export async function editStoreParams(param: IStoreManagementEditParams) {

  param = JSON.parse(JSON.stringify(param)) as IStoreManagementEditParams;

  try {
    const { code, message } = await Http.put<IStoreManagementEditParams>(`${hostUrl}/pay/yop/store`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 修改员工收款
 */
export async function changeStoreStatus(param: {storeId: number;status: number}) {

  param = JSON.parse(JSON.stringify(param)) as {storeId: number;status: number};

  try {
    const { code, message } = await Http.put<any>(`${hostUrl}/pay/yop/store/status`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 获取当前用户关联的门店信息
 */
export async function queryStoreCurrentUser() {

  try {
    const { code, message, context } = await Http.get<IStoreManagement>(`${hostUrl}/pay/yop/store/store-of-current-user`, {});

    if (code === EAxiosResponseCode.Succeed) {
      return context || {} as IStoreManagement;

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 修改门店手机号申请
 */
export async function changeStorePhoneApply(param: IStoreChangePhoneApplyParams) {

  let token = undefined;

  try {
    const { code, context, message } = await Http.post<{token: string}>(`${hostUrl}/pay/yop/store/change-store-mobile-apply`, param);

    if (code === EAxiosResponseCode.Succeed) {
      token = context?.token || undefined;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return token;
}

/**
 * 修改门店手机号验证
 */
export async function changeStorePhoneVerify(param: IStoreChangePhoneVerifyParams) {

  try {
    const { code, message } = await Http.post<{token: string}>(`${hostUrl}/pay/yop/store/change-store-mobile-verify`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询易宝已入网且操作授权已确认的公司列表
 */
export async function queryAuthYbCompanyList() {
  let data = [];

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/pay/yop/account/query/operate-auth-authorized-companies`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}
